import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import { message } from "antd";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import "react-datepicker/dist/react-datepicker.css";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { Button, Drawer } from "antd";
import { filterData } from "../../core/common/GlobalFunctions/tableFilters";
import { fetchAllBranch, UpdateBranch, createBranch, deletebranchById, } from "../../core/data/redux/branch/branch.Action";
import { decryptData } from "../../core/utils/encryptUtils";

const Branch = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const { user } = useSelector((state: any) => state.auth);
  const Id = selectedRowData?.Id;
  const [tableKey, setTableKey] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const { branch, loadingStates } = useSelector((state: any) => state.branch);
  const isLoading = isEditing ? loadingStates.update : loadingStates.create;
  const { employees } = useSelector((state: any) => state.employee);
  const [formData, setFormData] = useState({
    branchName: "",
    pincode: "",
    landmark: "",
    status: "active",
    description: "",
  });

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");

  const capitalize = (str: any) => str.charAt(0).toUpperCase() + str.slice(1);

  const handleDeletePolicy = (Id: any) => {
    dispatch(deletebranchById(Id))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          dispatch(fetchAllBranch());
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  const handleEditPolicy = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);
    setFormData({
      branchName: record.Branch_Name || "",
      pincode: record.Pincode || "",
      landmark: record.Landmark || "",
      status: record.Status || "active",
      description: record.Description || "",
    });
  };

  const handleSelectChange = (selectedOption: any, field: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: selectedOption?.value || "",
    }));
  };

  const handleDateChange = (date: Date | null, fieldName: string) => {
    setFormData((prev: any) => ({
      ...prev,
      [fieldName]: date ? date.toISOString().split("T")[0] : null,
    }));
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.branchName || formData.branchName.trim() === "") {
      message.error("Please enter a branch name");
      return false;
    }

    if (!formData.pincode || !/^\d{6}$/.test(formData.pincode)) {
      message.error("Please enter a valid 6-digit pincode");
      return false;
    }

    if (!formData.status) {
      message.error("Please select a status");
      return false;
    }


    return true;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = {
      ...formData,
      ...(isEditing ? { modifiedBy: user.UserId } : { createdBy: user.UserId }),
    };

    if (isEditing) {
      dispatch(UpdateBranch({ Id: Id, data: payload })).then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success("Updated  Successfully");
          dispatch(fetchAllBranch());
          setIsDrawerVisible(false);
          setFormData({
            branchName: "",
            pincode: "",
            landmark: "",
            status: "active",
            description: "",
          });
        } else {
          message.warning(res.payload.error);
        }
      });
    } else {
      dispatch(createBranch(payload)).then((res: any) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          setFormData({
            branchName: "",
            pincode: "",
            landmark: "",
            status: "active",
            description: "",
          });
          dispatch(fetchAllBranch());
           setIsDrawerVisible(false);
        } else {
          message.warning(res.payload.message);
        }
      });
    }
  };

  const formattedEmployees = employees.map((emp: any) => ({
    value: emp.EmployeeID,
    label: emp.Name,
  }));

  useEffect(() => {
    dispatch(fetchAllBranch());
  }, [dispatch]);

  const data = branch;

  const filteredData = useMemo(() => {
    return filterData(
      data || [],
      { Status: selectedStatus },
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [dispatch, branch, selectedSort, selectedStatus]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, branch, selectedSort, selectedStatus]);

  const columns = [
    {
      title: "Branch Name",
      dataIndex: "Branch_Name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          <h6 className="fw-medium mb-0">{record.Branch_Name}</h6>
        </div>
      ),
      sorter: (a: any, b: any) => a.Branch_Name.length - b.Branch_Name.length,
    },
    {
      title: "PinCode",
      dataIndex: "Pincode",
      sorter: (a: any, b: any) => a.Pincode.length - b.Pincode.length,
    },
    {
      title: "Landmark",
      dataIndex: "Landmark",
      sorter: (a: any, b: any) => a.Landmark.length - b.Landmark.length,
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a: any, b: any) => a.Description.length - b.Description.length,
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Icon – Always visible, disabled if canEdit is false */}
          <Link to="#" className="me-2"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Edit">
            <i
              className="ti ti-edit"
              onClick={() => {
                if (!canEdit) return;
                setIsEditing(true);
                handleEditPolicy(record);
                setIsDrawerVisible(true);
              }}
              style={{
                pointerEvents: canEdit ? "auto" : "none",
                cursor: canEdit ? "pointer" : "not-allowed",
                opacity: canEdit ? 1 : 0.5,
              }}
            />
          </Link>

          {/* Delete Icon – Always visible, disabled if canDelete is false or status is inactive */}
          <Link to="#"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Delete">
            <i
              className="ti ti-trash"
              onClick={() => {
                if (!canDelete || record.Status === "inactive") return;
                setSelectedRowData(record);
                setIsDeleteModalVisible(true);
              }}
              style={{
                pointerEvents:
                  canDelete && record.Status !== "inactive" ? "auto" : "none",
                cursor:
                  canDelete && record.Status !== "inactive"
                    ? "pointer"
                    : "not-allowed",
                opacity: canDelete && record.Status !== "inactive" ? 1 : 0.5,
              }}
            />
          </Link>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Branch</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  {/* <li className="breadcrumb-item">HR</li> */}
                  <li className="breadcrumb-item active" aria-current="page">
                    Branch
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canAdd && (
                <div className="mb-2">
                  <Button
                    type="primary"
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => {
                      setFormData({
                        branchName: "",
                        pincode: "",
                        landmark: "",
                        status: "active",
                        description: "",
                      });
                      setIsDrawerVisible(true);
                      setIsEditing(false);
                    }}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Branch
                  </Button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Termination List */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <h5 className="d-flex align-items-center">Branch List</h5>
                  <div className="d-flex align-items-center flex-wrap row-gap-3">
                    <div className="dropdown me-3">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedStatus
                          ? selectedStatus.charAt(0).toUpperCase() +
                          selectedStatus.slice(1)
                          : "Select Status"}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-3">
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedStatus("active")}
                            className="dropdown-item rounded-1"
                          >
                            Active
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedStatus("inactive")}
                            className="dropdown-item rounded-1"
                          >
                            Inactive
                          </Link>
                        </li>
                      </ul>
                    </div>

                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedSort
                          ? `Sort By : ${selectedSort}`
                          : "Sort By : Last 7 Days"}
                      </Link>
                      <ul className="dropdown-menu dropdown-menu-end p-3">
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Recently Added")}
                            className="dropdown-item rounded-1"
                          >
                            Recently Added
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Ascending")}
                            className="dropdown-item rounded-1"
                          >
                            Ascending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Descending")}
                            className="dropdown-item rounded-1"
                          >
                            Descending
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Last Month")}
                            className="dropdown-item rounded-1"
                          >
                            Last Month
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            onClick={() => setSelectedSort("Last 7 Days")}
                            className="dropdown-item rounded-1"
                          >
                            Last 7 Days
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <Table
                    key={tableKey}
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* /Termination List  */}
        </div>
        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between bg-white border-top p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      <>
        <Drawer
          title={isEditing ? "Update Branch" : "Add Branch"}
          placement="right"
          width={500}
          onClose={() => setIsDrawerVisible(false)}
          open={isDrawerVisible}
          style={{ marginTop: 50, paddingBottom: 50 }}
        >
          <form onSubmit={handleSubmit}>
            <div className="modal-body pb-0">
              <div className="row">
                {/* Branch Name */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Branch Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="branchName"
                      value={formData.branchName}
                      onChange={handleInputChange}
                      placeholder="Enter Branch Name"
                    />
                  </div>
                </div>

                {/* Pincode */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Pincode <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleInputChange}
                      placeholder="Enter Pincode"
                    />
                  </div>
                </div>

                {/* Landmark */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Landmark
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="landmark"
                      value={formData.landmark}
                      onChange={handleInputChange}
                      placeholder="Enter Landmark"
                    />
                  </div>
                </div>

                {/* Status */}
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Status <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="select"
                      options={[
                        { value: "active", label: "Active" },
                        { value: "inactive", label: "Inactive" },
                      ]}
                      value={
                        formData.status
                          ? {
                            value: formData.status,
                            label: capitalize(formData.status),
                          }
                          : null
                      }
                      onChange={(selectedOption: any) =>
                        handleSelectChange(selectedOption, "status")
                      }
                      placeholder="Select Status"
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="form-label">
                      Description
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      placeholder="Enter Description"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-white border me-2"
                onClick={() => setIsDrawerVisible(false)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={isLoading}>
                {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
                {isEditing ? "Update Branch" : "Add Branch"}
              </button>
            </div>

          </form>
        </Drawer>

        {/* /Edi Termination */}
        {/* Delete Modal */}
        <DeleteModal1
          isVisible={isDeleteModalVisible}
          onClose={() => setIsDeleteModalVisible(false)}
          onConfirm={() =>
            selectedRowData?.Id && handleDeletePolicy(selectedRowData.Id)
          }
        />
        {/* /Delete Modal */}
      </>
    </>
  );
};

export default Branch;
